import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL || "http://localhost:4000/graphql",
});

// Middleware to add API key to headers
const authLink = setContext((_, { headers }) => {
  // Get API key from environment variable
  const apiKey = process.env.REACT_APP_API_SECRET_KEY;
  
  return {
    headers: {
      ...headers,
      // Add API key if available (required for production)
      ...(apiKey ? { "x-api-key": apiKey } : {}),
    },
  };
});

// Create Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
